import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import Storage from '../../services/storage';
export default function useStorage(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$storageMechanism = _ref.storageMechanism,
    storageMechanism = _ref$storageMechanism === void 0 ? Storage.LOCAL_STORAGE : _ref$storageMechanism,
    _ref$expiry = _ref.expiry,
    expiry = _ref$expiry === void 0 ? null : _ref$expiry;
  var options = {
    storageMechanism: storageMechanism,
    expiry: expiry
  };
  if (typeof window === 'undefined') {
    return [];
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    storageLoaded = _useState2[0],
    setStorageLoaded = _useState2[1];
  var _useState3 = useState(defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  useEffect(function () {
    var valueStored = Storage.get(key, defaultValue, options);
    setValue(valueStored);
    setStorageLoaded(true);
  }, []);
  function setValueLocalStorage(newValue) {
    if (storageLoaded) {
      setValue(newValue);
      Storage.set(key, newValue, options);
    }
  }
  return [value, setValueLocalStorage, storageLoaded];
}